@let bonuses = bonusesSignal();

<wilson-working-time-section-wrapper
  [title]="'page.working_time.bonuses.title' | translate"
  [isLoading]="isLoadingBonuses()"
  [shouldHide]="bonuses.length === 0 && !isLoadingBonuses() && !hasError()"
>
  @if (bonuses.length === 0 && hasError()) {
    <ion-label class="ion-padding">
      {{ 'general.n/a' | translate }}
    </ion-label>
  } @else {
    @for (bonus of bonuses; track bonus.name) {
      <ion-col size="6">
        <wilson-worktime-metrics-card
          [header]="bonus.translatedName"
          [values]="
            bonus.name === PayrollCategoryName.PerDiem
              ? [bonus.sum]
              : [bonus.temporarySum, bonus.sum]
          "
          [unit]="bonus.wageReportUnit"
        />
      </ion-col>
    }
  }
</wilson-working-time-section-wrapper>
